<template>
  <div class="view">
    <div class="content" v-if="loadingStatus">
      <div class="auth_c" v-if="authorizationInfo">
        <el-form label-width="120px">
          <el-form-item label="公众号昵称：">{{authorizationInfo.name}}</el-form-item>
          <el-form-item label="主体信息：">{{authorizationInfo.principal_name}}</el-form-item>
          <el-form-item label="授权状态：">已授权</el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="refreshWxpub">刷新</el-button>
          </el-form-item>
        </el-form>
        <div class="infodescribe mb-40" style="height: auto">
          <p class="yellow"><i class="el-icon-warning yellow"></i>&nbsp;提示：使用云知授权和自己企业服务号授权的区别：由于是使用云知授权，企业会获取不了访问获客文章的客户基本信息，客户信息无法合并到一起。例如：你们公司使用了云知授权，A访客看了你的获客文章又查看了你的小程序，那在你的线索列表就会有两个A。</p>
          <p class="info-danger"><i class="el-icon-warning info-danger"></i>&nbsp;注意：如果授权错误或者想取消授权，请到微信公众号后台->公众号设置->授权管理，选择造像时代，取消授权</p>
        </div>
        <div>
          <div class="access_title">
            <p>服务号文章已同步到APP企业文库。关联公众号，可同步更多文章至APP企业文库。</p><el-button icon="el-icon-plus" type="success" size="small" round @click="refreshWxpubLink">关联公众号</el-button>
          </div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column label="公众号名称" prop="name">
            </el-table-column>
            <el-table-column prop="principal_name" label="主体信息"></el-table-column>
            <el-table-column prop="cat_id" label="是否开启文章同步">
              <template slot-scope="scope">
                <el-switch
                        v-model="scope.row.switchStatus"
                        active-color="#2AA3F8"
                        inactive-color="#ff4949"
                        @change="switchStatusChange($event,scope.$index)">
                </el-switch>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作">
              <template slot-scope="scope">

              </template>
            </el-table-column> -->
          </el-table>
        </div>

      </div>
      <div class="authorization-body" v-else>
        <p class="authorization-body-status"><span>授权状态: </span>未授权</p>
        <p class="authorization-body-button mb-20">
          <el-button size="small" type="primary" @click="openWxpub">进行服务号授权</el-button>
        </p>
        <div class="authorization-body-desc">
          <p class="authorization-body-desc-title mb-10">服务号授权须知</p>
          <p class="authorization-body-desc-list">1、授权的微信公众号必须与开通名片的小程序是同一主体</p>
          <p class="authorization-body-desc-list">2、授权的微信公众号必须是微信认证的服务号</p>
          <p class="authorization-body-desc-list">3、扫码授权后请耐心等待3秒，过程中不可提前关闭页面，跳转回企管后台点击【授权成功】</p>
          <p class="authorization-body-desc-list info-danger">4、如果授权错误或者想取消授权，请到微信公众号后台->公众号设置->授权管理，选择造像时代，取消授权</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "articlePannel",
    data() {
      return {
        tableData:[],
        loadingStatus: false,
        authorizationInfo: null
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axiosFnLink(1,api.company_wxpub_index)
      },
      openWxpub() {
        this.axiosFnLink(2,api.company_wxpub_wx_author)
      },
      refreshWxpub() {
        this.axiosFnLink(3, api.company_wxpub_refresh)
      },
      // 授权链接 company_wxpub_wx_access
      refreshWxpubLink(){
        this.axiosFnLink(4, api.company_wxpub_wx_access)
      },
      axiosFnLink(type,url){
        // type 1 进入数据 2 绑定授权服务号 3 刷新服务号信息 4 关联公众号
        let this_ = this;
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.axios
            .post(url, {})
            .then(response => {
              if (response.data.code == 0) {
                if(type===1){
                  this.authorizationInfo = response.data.info
                  for(let i in response.data.list){
                    let switchStatus = false
                    if(response.data.list[i].is_synchronous===1){
                      switchStatus = true
                    }
                    response.data.list[i].switchStatus = switchStatus
                  }
                  this.tableData = response.data.list
                }else if(type===2 || type===4){
                  window.open('https://api.zaoxiangguan.com/companyadmin/login/jump?url=' + response.data.url)
                  this.$confirm('是否成功授权？', '提示', {
                    confirmButtonText: '已成功授权',
                    cancelButtonText: '授权失败',
                    type: 'warning'
                  }).then(() => {
                    this_.InitFn()
                  }).catch(() => {
                    this_.InitFn()
                  });
                }else if(type===3){
                  this.authorizationInfo.name = response.data.info.name
                  this.authorizationInfo.principal_name = response.data.info.principal_name
                }
              } else {
              }
              loading.close();
              this.loadingStatus = true
            })
            .catch(response => {
            });
      },
      switchStatusChange(even, index){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        // 文章同步开关(0关闭、1开启) is_synchronous; pub_id:  	公众号id
        let data_ = {
          is_synchronous: even?'1':'0',
          pub_id: this.tableData[index].id
        }
        this.axios
            .post(api.company_wxpub_synchronous, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '设置成功',
                });
              }
              loading.close();
            })
            .catch(response => {
            });
      }
    }
  };
</script>
